import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IAppState } from "../../../redux/reducers";
import MoreOptions from "../../shared-ui/more-options";
import { IPopupMenuOption } from "../../shared-ui/popup-menu";
import { IIAMCredentialMeta } from "api/entities/iam-credentials";
import { iamCredentialsActions } from "redux/actions/iam-credentials";

const mapDispatchToProps = (
    dispatch: ThunkDispatch<IAppState, void, Action>
) => {
    return {
        openDeleteConfirmation: (credentialsItem: IIAMCredentialMeta) =>
            dispatch(iamCredentialsActions.deleteConfirmation.open(credentialsItem))
    };
};

export interface IMoreOptionProps
    extends ReturnType<typeof mapDispatchToProps> {

    data: IIAMCredentialMeta;
}

export const MoreOption = connect(null, mapDispatchToProps)((props: IMoreOptionProps) => {

    const [options, setOptions] = useState<IPopupMenuOption[]>(getOptions());

    function openDeleteConfirmation() {
        props.openDeleteConfirmation(props.data);
    }

    function getOptions(): IPopupMenuOption[] {
        const result = [
            {
                label: "Delete",
                onClick: openDeleteConfirmation
            }
        ];

        return result;
    }

    useEffect(() => {

        setOptions(getOptions());

        // eslint-disable-next-line
    }, []);

    return (
        <MoreOptions
            options={options}
        />
    );
});
